import type { ThreadReaderContext } from '@/modules/threads/reads.api'

import { useThreadAccessSession } from './useThreadAccessSession'

/** Readers and writers capture the same actor and explicit client context;
 * source/action authorization stays in the application service. */
export function useThreadReadSession() {
  const access = useThreadAccessSession()
  return {
    ...access,
    staffEnabled: access.enabled && access.owner?.portalEntityId === null,
    async run<T>(
      signal: AbortSignal,
      read: (context: ThreadReaderContext) => Promise<T>,
    ): Promise<T> {
      return access.run(signal, linked =>
        read({
          organizationId: access.owner!.organizationId,
          userId: access.owner!.userId,
          portalEntityId: access.owner!.portalEntityId,
          signal: linked,
        }),
      )
    },
  }
}
